import React, { useEffect, useContext } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { BrowserRouter, StaticRouter } from 'react-router-dom';

import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { pageViewComposer } from '@bibliocommons/analytics-event-composers';
import { useRouter } from '@bibliocommons/utils-routing';
import Context from '@bibliocommons/context';
import { removeSessionStorageItem } from '@bibliocommons/utils-storage';

import { SEARCH_ORIGIN_QUERY_PARAM } from 'app/constants/AnalyticsConstants';
import { trackPageView } from 'app/actions/AnalyticsGa4Actions';
import routes from './routes';

const Router = __SERVER__ ? StaticRouter : BrowserRouter;

export function Routes() {
  const { location, query } = useRouter();
  const { backToLinkEnabled, hydrated } = useContext(Context);
  const dispatch = useDispatch();

  useEffect(() => {
    // Skip analytics tracking if we know that
    // the page component will immediately perform a router.replace
    const isSkipTracking = location.pathname === '/v2/search' && Boolean(query[SEARCH_ORIGIN_QUERY_PARAM]);

    let bibId = null;

    if (location.pathname.startsWith('/v2/record/')) {
      bibId = /^\/v2\/record\/([^/]+)\/?/.exec(location.pathname)?.[1] ?? null;
    }

    if (!isSkipTracking) {
      sendAnalyticsEvents(pageViewComposer.composePageViewEvent());

      dispatch(trackPageView({ bibId, list: null }));
    }

    // Update the active header nav everytime the location changes
    if (window.BCHeaderPublic) {
      window.BCHeaderPublic('setActiveNavItem');
    }
  }, [dispatch, location, query]);

  useEffect(() => {
    if (!backToLinkEnabled && hydrated) {
      removeSessionStorageItem('backToLink');
    }
  }, [backToLinkEnabled, hydrated]);

  return routes;
}

export default function ApplicationRouter(props) {
  return (
    <Router {...props}>
      <Routes />
    </Router>
  );
}

ApplicationRouter.propTypes = {
  location: PropTypes.string
};
